import moment from 'moment';
import { FC, useMemo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { IWorkingHoursModalParams } from 'src/mobx/modalStore/types';
import { formatDate, getTranslate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { getWorkingHoursOrderTypeIcons } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/helpers/branchEdit';
import './style.scss';

interface IProps {
  id: number;
  startTime: string;
  closeTime: string;
  orderType: number | undefined;
  menuGroupId: number | undefined;
  menuGroupName: string | undefined;
  withoutMenuGroup?: boolean | undefined;
  withoutOrderType?: boolean | undefined;
  onClick: (params?: Partial<IWorkingHoursModalParams>) => void;
}

const SlotCard: FC<IProps> = ({
  id,
  startTime,
  closeTime,
  orderType,
  menuGroupId,
  menuGroupName,
  withoutMenuGroup,
  withoutOrderType,
  onClick,
}): JSX.Element => {
  const isFullDay = useMemo(() => {
    const workingHoursDuration = moment
      .duration(moment(closeTime, 'HHmmss').diff(moment(startTime, 'HHmmss')))
      .add(1, 'minute') // add extra minute because edge close time is 23:59
      .asHours();

    return Math.floor(workingHoursDuration) === 24;
  }, [closeTime, startTime]);

  const orderTypeIcons: Icons[] = useMemo(() => (orderType !== undefined ? getWorkingHoursOrderTypeIcons(orderType) : []), [orderType]);

  const handleSlotCardClick = () => {
    return onClick({
      id,
      startTime,
      closeTime,
      menuGroupId,
      menuGroupName,
      orderType,
      isFullDay,
      withoutMenuGroup,
      withoutOrderType,
    });
  };

  return (
    <div className="slot-card" onClick={handleSlotCardClick}>
      {isFullDay ? (
        <div className="slot-card__full-hours">
          <div className="pos-relative">
            <div className="slot-card__full-hours-icon">24</div>
            <Icon name={Icons.TimeLeft} size={60} className="color-gray2" />
          </div>
          <p className="family-medium text-size-20 mt-2 mr-2">{localeStore.t('branch_timeslot_open_24_hours')}</p>
        </div>
      ) : (
        <div className="d-flex flex-row">
          <p className="family-semibold text-size-20 letter-spacing-2">
            {formatDate(moment(startTime, 'HHmmss'), { onlyTime: true, timeFormat: 'hh:mm' })}
          </p>
          <div className="slot-card__time-dash" />
          <p className="family-semibold text-size-20 letter-spacing-2">
            {formatDate(moment(closeTime, 'HHmmss'), { onlyTime: true, timeFormat: 'hh:mm' })}
          </p>
        </div>
      )}
      {withoutMenuGroup ? null : <p className="family-regular text-size-16 text-elipsis my-3">{getTranslate(menuGroupName)}</p>}
      {withoutOrderType ? null : (
        <div className="d-flex flex-row gap-10">
          {orderTypeIcons.map((orderTypeIcon) => (
            <Icon name={orderTypeIcon} className="color-gray2" />
          ))}
        </div>
      )}
    </div>
  );
};

export default SlotCard;
